import Controller from '../abstracts/Controller';
import 'scss-templates/t-login.scss';

export default class LoginController extends Controller {
  static get COMPONENTS() {
    return [
      // 'LoginComponent',
      'ShowPasswordComponent',
      // 'NewsletterComponent'
    ];
  }
}
